import {Component, inject, input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {DirectusService} from '@frontend/directus';
import {toObservable, toSignal} from '@angular/core/rxjs-interop';
import {switchMap} from 'rxjs';
import {TranslateDirectusPipe, TranslateDirectusTemplatePipe} from '@frontend/transloco';
import {Panel} from 'primeng/panel';
import {TableModule} from 'primeng/table';
import {SafeHtmlComponent} from '../../safe-html-output/safe-html-output.component';

@Component({
  selector: 'app-trusted-text-preview',
  imports: [
    CommonModule,
    FormsModule,
    TranslateDirectusPipe,
    TranslateDirectusTemplatePipe,
    Panel,
    TableModule,
    SafeHtmlComponent,
  ],
  templateUrl: './trusted-text-preview.component.html',
  providers: [TranslateDirectusTemplatePipe],
})
// Use only for Directus text, without user actions
// this uses app-safe-html-output, which disables Angular XSS attach check
export class TrustedTextPreviewComponent {
  private readonly directusService = inject(DirectusService);

  readonly textKey = input.required<string>();

  readonly textTemplate = toSignal(
    toObservable(this.textKey).pipe(switchMap((key) => this.directusService.loadTextTemplate(key))),
    {initialValue: null},
  );
}
